<template>
  <div>
    <div class="productBar">
      <div class="auto">
        <h2>
          产品：大智慧365版
          <span>非投资咨询类软件产品</span>
        </h2>
      </div>
    </div>
    <div class="slogan365">
      <div class="auto pr">
        <dl>
          <dt>大智慧365版</dt>
          <dd>极速行情 简易操盘 领跑股市</dd>
          <dd>资金面 基本面 技术面 黄金三角 <br>&nbsp;&nbsp;&nbsp;轻松解决炒股难题</dd>
          <dd>选股、买卖、资讯 一站解决</dd>
        </dl>
        <router-link :to="'/order/confirm/' + id + '/12?s=official'" class="buy">立刻购买</router-link>
        <img src="../../assets/images/product/116/img01.png" alt class="computer">
      </div>
    </div>
    <div class="intro365 pr">
      <div class="auto">
        <dl>
          <dt>AI决策：（四维战法）</dt>
          <dd>通过对价量筹码资金等多种分析方法的融合。避免了单一指标发出失真信号的出现。</dd>
          <dd>
            <ul>
              <li>
                <div>
                  <strong>黄金波段</strong>
                  <span>第一时间揭示顶背离和底背离</span>
                </div>
              </li>
              <li>
                <div>
                  <strong>市场热度</strong>
                  <span>多空热度一手掌握</span>
                </div>
              </li>
              <li>
                <div>
                  <strong>GDX</strong>
                  <span>深度挖掘活跃资金的市场行为</span>
                </div>
              </li>
              <li>
                <div>
                  <strong>黄金狙击</strong>
                  <span>变盘信号早知道</span>
                </div>
              </li>
            </ul>
            <img src="../../assets/images/product/116/img02.png" alt>
          </dd>
        </dl>
        <dl>
          <dt>热钱追踪</dt>
          <dd>热钱是短期股价运作的幕后推手</dd>
          <dd>
            <p>
              1、DDE决策系统多维度监控各路资金流入的板块、个股；
              <br>2、助力投资者紧跟热钱的脚步，洞悉市场动态。
            </p>
            <div class="img">
              <img src="../../assets/images/product/116/img03.png" alt>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>智能复盘</dt>
          <dd>
            智能梳理市场脉络、实时涨跌比等全新数据模型助您及时了解市场风向。
            <div class="img">
              <img src="../../assets/images/product/116/img04.jpg" alt>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>波段为王</dt>
          <dd>
            把握波段运行的规律，抓住上涨波段的相对底部介入，并在相对顶部避险。
            <img src="../../assets/images/product/116/img05.png" alt>
          </dd>
        </dl>
        <dl>
          <dt>游资大剖析</dt>
          <dd>
            追踪分类席异动个股的席位和买卖操作。
            <img src="../../assets/images/product/116/img06.png" alt>
          </dd>
        </dl>
      </div>
    </div>
    <float-bar :id="id" :month="month"/>
  </div>
</template>
<script>
import FloatBar from "@/components/product/FloatBar.vue";
export default {
  data() {
    return {
      id: this.$parent.id,
      month : 12,
      wxCodeActive: false,
      telActive: false
    };
  },
  created () {
    document.title = "大智慧365";
  },
  components:{
    FloatBar
  }
};
</script>

<style scope>
.slogan365 {
  background: url(~@/assets/images/product/116/bg02.jpg) no-repeat left top;
  height: 1000px;
  position: relative;
  width: 100%;
  z-index: 2;
}

.slogan365 dl {
  margin: 0px 0 0 70px;
  color: #fff;
  padding-top: 210px;
}

.slogan365 dt {
  font-size: 46px;
  margin-bottom: 50px;
}

.slogan365 dd {
  font-size: 20px;
  margin-bottom: 30px;
}

.slogan365 dd:before {
  content: "";
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  vertical-align: middle;
  margin-right: 14px;
}

.slogan365 .buy {
  display: block;
  width: 217px;
  height: 60px;
  font-size: 26px;
  color: #fff;
  border-radius: 30px;
  background: linear-gradient(to right, #50fce2, #1aa6ff);
  text-align: center;
  line-height: 60px;
  margin-left: 70px;
}

.slogan365 .computer {
  position: absolute;
  left: 480px;
  top: 188px;
}

.slogan365:after {
  content: "";
  display: block;
  background: url(~@/assets/images/product/116/bg03.jpg) no-repeat;
  width: 310px;
  height: 455px;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: -1;
}
.intro365 dl dt,
.intro365 dl dd ul li:before,
.intro365:before,
.intro365:after,
.intro365 dl:nth-child(2) dd .img:before {
  background-image: url(~@/assets/images/product/116/icon.png);
  background-repeat: no-repeat;
}
.intro365 {
  overflow: hidden;
}

.intro365 dl {
  margin-bottom: 30px;
}

.intro365 dl:first-child dt {
  background-position: 0 0;
  width: 468px;
  height: 112px;
  text-align: center;
  line-height: 120px;
}

.intro365 dl dt {
  font-size: 42px;
  color: #fff;
  text-shadow: 0 4px 3px rgba(0, 0, 0, 0.32);
  background-position: 0 -122px;
  width: 278px;
  height: 109px;
  line-height: 109px;
  margin: 0 0 30px 0px;
  text-align: center;
}

.intro365 dl dd:first-of-type {
  font-size: 26px;
  color: #262626;
  margin-left: 25px;
}

.intro365 dl dd:first-of-type:before {
  content: "";
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #464646;
  vertical-align: middle;
  margin-right: 14px;
}

.intro365 dl dd ul {
  margin: 65px 0 50px 30px;
  overflow: hidden;
}

.intro365 dl dd ul li {
  float: left;
  margin-right: 60px;
}

.intro365 dl dd ul li:last-child {
  margin-right: 0;
}

.intro365 dl dd ul li div {
  float: left;
}

.intro365 dl dd ul li:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
  float: left;
}

.intro365 dl dd ul li strong {
  font-size: 20px;
  color: #131313;
  display: block;
}

.intro365 dl dd ul li span {
  font-size: 18px;
  color: #a9a9a9;
}

.intro365 dl dd ul li:first-child:before {
  background-position: 0 -240px;
  width: 44px;
  height: 51px;
}

.intro365 dl dd ul li:nth-child(2):before {
  background-position: -59px -240px;
  width: 40px;
  height: 51px;
}

.intro365 dl dd ul li:nth-child(3):before {
  background-position: -120px -240px;
  width: 48px;
  height: 48px;
}

.intro365 dl dd ul li:nth-child(4):before {
  background-position: -189px -240px;
  width: 52px;
  height: 48px;
}

.intro365 dl dd img {
  margin: auto;
  display: block;
}

.intro365 dl:nth-child(2) {
  position: relative;
}

.intro365 dl:nth-child(2) dd p {
  font-size: 23px;
  color: #394ef4;
  line-height: 40px;
  margin: 30px 0 50px 50px;
}

.intro365 dl dd .img {
  position: relative;
  width: 1260px;
  padding: 30px;
  box-shadow: 0 4px 34px rgba(0, 53, 199, 0.3);
  border-radius: 10px;
  box-sizing: border-box;
}

.intro365 dl dd .img img {
  width: 100%;
}

.intro365 dl:nth-child(2) dd .img:before {
  content: "";
  display: block;
  background-position: right -132px;
  width: 61px;
  height: 70px;
  left: 980px;
  top: -50px;
  position: absolute;
}

.intro365 dl:nth-child(3) dd.img {
  width: 1155px;
  /* margin-top: ; */
}

.intro365:before {
  content: "";
  display: block;
  background-position: -294px -249px;
  width: 175px;
  height: 251px;
  left: 50%;
  top: 1630px;
  position: absolute;
  margin-left: 630px;
}

.intro365:after {
  content: "";
  display: block;
  background-position: 0 -311px;
  width: 140px;
  height: 279px;
  left: 50%;
  top: 2750px;
  position: absolute;
  margin-left: -744px;
}
.intro365 dl:first-child dd:nth-of-type(2) img{
  margin-left: 80px;
}
.intro365 dl:nth-child(4) dd:nth-of-type(1) img{
  margin-left: 146px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/Product116.vue